















































































































































































import {Vue, Component, Watch, Ref} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import SummerNote from '@/components/common/summernote/Index.vue';
import {getToday} from '@/utils/dateUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {emptyCheck} from '@/utils/validateUtils';
import {ncpPopup} from '@/utils/ncp';
import TuiGrid from 'tui-grid';
import { addProductDetailUrlPreview } from '@/utils/formatUtils';
import {Mall, GetPopupsPopupNoRequest, DisplayCategoriesTree, GetEventsEnentNoRequest, PostPopupsRequest, PutPopupsPopupNoRequest, PostProductsSearchByKeyRequest} from 'supporter';
import moment from 'moment';
import { DEFAULT_TIME_RANGE } from '@/pro/components/common/datepicker/dateRange';
import { convertProductUri } from '@/utils/commonUtils';

const mallModule = namespace('mall');
@Component({
  components: {CompSelectBox, RadioElement, CheckBoxElement, ItemTable, DateCalendar, ValidateInput, SummerNote}
})
export default class PopupDetail extends Vue {
  private editFlg = false;
  private editNo = 0;
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: string = '';
  private productDetailUrl: string = '';
  private get mallList() {
    let list: any = [];
    if (this.malls) {
      this.malls.forEach((mall) => {
        if (mall.used) {
          list.push({
            value: mall.mallNo.toString(),
            name: mall.mallName
          });
        }
      });
    }
    return list;
  }
  private async selectMall() {
    (this.$refs.pageTypes as any).setValues('MAIN');
    this.showPageTypes = 'MAIN';
    const {data} = await this.$api.getDisplayCategoriesTree({params: {mallNo: Number(this.mallNo)}});
    this.displayCategoryAll = 'Y';
    this.categoriesInfo.categoriesTree = data;
    this.categoriesInfo.selectedCategories = [];
    this.categoriesInfo.selected1Depth = 0;
    this.categoriesInfo.selected2Depth = 0;
    this.categoriesInfo.selected3Depth = 0;
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
    this.eventAll = 'Y';
    this.eventNo = '';
    this.eventInfos = [];
    this.mallProductAll = 'Y';
    let mallConf = await this.$api.getProductsConfiguration({params: {mallNo: Number(this.mallNo)}});
    this.productDetailUrl = addProductDetailUrlPreview(mallConf.data.productDetailUrl);
  }

  @Ref('content')
  private readonly contentRef: SummerNote;

  // 팝업명
  private popupName: string = '';

  // 사이즈
  // 가로
  private popupWidth: string = '300';
  private popupWidthOptions = {
    name: 'popupWidth',
    type: 'text-num',
    maxlength: 9
  };
  // 세로
  private popupHeight: string = '300';
  private popupHeightOptions = {
    name: 'popupHeight',
    type: 'text-num',
    maxlength: 9
  };

  // 형태
  private popupType: string = 'WINDOW';
  private popupTypes = {
    name: 'popupType',
    data: [
      {
        id: 'popupType_WINDOW',
        value: 'WINDOW',
        dispaly: 'DISPLAY_POPUP_POPUP_TYPE_WINDOW'
      },
      {
        id: 'popupType_LAYER',
        value: 'LAYER',
        dispaly: 'DISPLAY_POPUP_POPUP_TYPE_LAYER'
      }
    ]
  };

  // 플랫폼별 노출 설정
  private popupDisplayType: string = 'ALL';
  private displayTypes = {
    name: 'displayTypes',
    data: [
      {
        id: 'displayTypes_ALL',
        value: 'ALL',
        dispaly: 'DISPLAY_POPUP_DISPLAY_TYPE_ALL'
      },
      {
        id: 'displayTypes_CUSTOMIZED',
        value: 'CUSTOMIZED',
        dispaly: 'DISPLAY_POPUP_DISPLAY_TYPE_CUSTOMIZED'
      }
    ]
  };
  private showPlatformTypes: string = '';
  private platformTypes = {
    name: 'platformTypes',
    hasAll: false,
    brackets: true,
    data: [
      {
        id: 'PC',
        value: 'PC',
        dispaly: 'DISPLAY_POPUP_PLATFORM_TYPE_PC'
      },
      {
        id: 'MOBILE_APP',
        value: 'MOBILE_APP',
        dispaly: 'DISPLAY_POPUP_PLATFORM_TYPE_MOBILE_APP'
      },
      {
        id: 'MOBILE_WEB',
        value: 'MOBILE_WEB',
        dispaly: 'DISPLAY_POPUP_PLATFORM_TYPE_MOBILE_WEB'
      }
    ]
  };

  // 적용 페이지 설정
  private showPageTypes: string = 'MAIN';
  private pageTypes = {
    name: 'pageTypes',
    hasAll: false,
    data: [
      {
        id: 'MAIN',
        value: 'MAIN',
        dispaly: 'DISPLAY_POPUP_PAGE_TYPE_MAIN_1'
      },
      {
        id: 'CATEGORY',
        value: 'CATEGORY',
        dispaly: 'DISPLAY_POPUP_PAGE_TYPE_CATEGORY'
      },
      {
        id: 'EVENT',
        value: 'EVENT',
        dispaly: 'DISPLAY_POPUP_PAGE_TYPE_EVENT'
      },
      {
        id: 'PRODUCT',
        value: 'PRODUCT',
        dispaly: 'DISPLAY_POPUP_PAGE_TYPE_PRODUCT'
      }
    ]
  };

  // 전시 카테고리
  private categoriesInfo = {
    selectedCategories: [] as any,
    selected1Depth: 0,
    selected2Depth: 0,
    selected3Depth: 0,
    selected4Depth: 0,
    selected5Depth: 0,
    categoriesTree: []
  };
  private get showCategoryInfo() {
    let showFlg = false;
    this.showPageTypes.split(',').forEach((item: any) => {
      if (item === 'CATEGORY') {
        showFlg = true;
      }
    });
    return showFlg;
  }
  private displayCategoryAll: string = 'Y';
  private displayCategoryTypes = {
    name: 'displayCategoryTypes',
    data: [
      {
        id: 'displayCategoryTypes_Y',
        value: 'Y',
        dispaly: 'DISPLAY_POPUP_CATEGORY_ALL'
      },
      {
        id: 'displayCategoryTypes_N',
        value: 'N',
        dispaly: 'DISPLAY_POPUP_CATEGORY_PART'
      }
    ]
  };
  private get depth1List() {
    let depth1 = [
      {
        value: 0,
        name: '1Depth',
        parentName: '',
        displayOrder: 0,
        info: null as any
      }
    ];
    if (this.categoriesInfo.categoriesTree && this.categoriesInfo.categoriesTree.length > 0) {
      this.categoriesInfo.categoriesTree.forEach((item: DisplayCategoriesTree) => {
        depth1.push({
          value: item.displayCategoryNo,
          name: item.displayCategoryName,
          parentName: '',
          displayOrder: item.displayOrder,
          info: item
        });
      });
    }
    return depth1.sort((a, b) => {
      return a.displayOrder > b.displayOrder ? 1 : -1;
    });
  }
  private get depth2List() {
    let depth2 = [
      {
        value: 0,
        name: '2Depth',
        parentName: '',
        displayOrder: 0,
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected1Depth !== 0) {
      this.depth1List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected1Depth) {
          if (item.info.children.length) {
            item.info.children.forEach((item2: any) => {
              depth2.push({
                value: item2.displayCategoryNo,
                name: item2.displayCategoryName,
                parentName: item.name,
                displayOrder: item.displayOrder,
                info: item2
              });
            });
          }
        }
      });
    }
    return depth2.sort((a, b) => {
      return a.displayOrder > b.displayOrder ? 1 : -1;
    });
  }
  private get depth3List() {
    let depth3 = [
      {
        value: 0,
        name: '3Depth',
        parentName: '',
        displayOrder: 0,
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected2Depth !== 0) {
      this.depth2List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected2Depth) {
          if (item.info.children.length) {
            item.info.children.forEach((item2: any) => {
              depth3.push({
                value: item2.displayCategoryNo,
                name: item2.displayCategoryName,
                parentName: `${item.parentName}>${item.name}`,
                displayOrder: item.displayOrder,
                info: item2
              });
            });
          }
        }
      });
    }
    return depth3.sort((a, b) => {
      return a.displayOrder > b.displayOrder ? 1 : -1;
    });
  }
  private get depth4List() {
    let depth4 = [
      {
        value: 0,
        name: '4Depth',
        parentName: '',
        displayOrder: 0,
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected3Depth !== 0) {
      this.depth3List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected3Depth) {
          if (item.info.children.length) {
            item.info.children.forEach((item2: any) => {
              depth4.push({
                value: item2.displayCategoryNo,
                name: item2.displayCategoryName,
                parentName: `${item.parentName}>${item.name}`,
                displayOrder: item.displayOrder,
                info: item2
              });
            });
          }
        }
      });
    }
    return depth4.sort((a, b) => {
      return a.displayOrder > b.displayOrder ? 1 : -1;
    });
  }
  private get depth5List() {
    let depth5 = [
      {
        value: 0,
        name: '5Depth',
        parentName: '',
        displayOrder: 0,
        info: null as any
      }
    ];
    if (this.categoriesInfo.selected4Depth !== 0) {
      this.depth4List.forEach((item: any) => {
        if (item.value === this.categoriesInfo.selected4Depth) {
          if (item.info.children.length) {
            item.info.children.forEach((item2: any) => {
              depth5.push({
                value: item2.displayCategoryNo,
                name: item2.displayCategoryName,
                parentName: `${item.parentName}>${item.name}`,
                displayOrder: item.displayOrder,
                info: item2
              });
            });
          }
        }
      });
    }
    return depth5.sort((a, b) => {
      return a.displayOrder > b.displayOrder ? 1 : -1;
    });
  }
  private changeDepth1() {
    this.categoriesInfo.selected2Depth = 0;
    this.categoriesInfo.selected3Depth = 0;
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
  }
  private changeDepth2() {
    this.categoriesInfo.selected3Depth = 0;
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
  }
  private changeDepth3() {
    this.categoriesInfo.selected4Depth = 0;
    this.categoriesInfo.selected5Depth = 0;
  }
  private changeDepth4() {
    this.categoriesInfo.selected5Depth = 0;
  }
  private showCategoryErr: boolean = false;
  private addCategory() {
    this.showCategoryErr = false;
    let category = null as any;
    let depth = 0;
    if (this.categoriesInfo.selected5Depth !== 0) {
      depth = 5;
      category = this.depth5List.find((item: any) => item.value === this.categoriesInfo.selected5Depth);
    } else if (this.categoriesInfo.selected4Depth !== 0) {
      depth = 4;
      category = this.depth4List.find((item: any) => item.value === this.categoriesInfo.selected4Depth);
    } else if (this.categoriesInfo.selected3Depth !== 0) {
      depth = 3;
      category = this.depth3List.find((item: any) => item.value === this.categoriesInfo.selected3Depth);
    } else if (this.categoriesInfo.selected2Depth !== 0) {
      depth = 2;
      category = this.depth2List.find((item: any) => item.value === this.categoriesInfo.selected2Depth);
    } else {
      depth = 1;
      category = this.depth1List.find((item: any) => item.value === this.categoriesInfo.selected1Depth);
    }
    let haveFlg = false;
    this.categoriesInfo.selectedCategories.forEach((selectedItem: any) => {
      if (selectedItem.displayCategoryNo === category.value) {
        haveFlg = true;
      }
    });
    if (!haveFlg) {
      let showName = category.name;
      if (category.parentName !== '') {
        showName = `${category.parentName}>${showName}`;
      }
      if (category.info.displayYn === 'N') {
        showName += '<span class="ico_noshow"></span>';
      }
      this.categoriesInfo.selectedCategories.push({
        showName,
        depth,
        displayCategoryNo: category.value
      });
    } else {
      this.showCategoryErr = true;
    }
  }
  private delCategory(categoryNo: any) {
    this.categoriesInfo.selectedCategories = this.categoriesInfo.selectedCategories.filter((item: any) => item.displayCategoryNo !== categoryNo);
  }

  // 기획전
  private get showEventInfo() {
    let showFlg = false;
    this.showPageTypes.split(',').forEach((item: any) => {
      if (item === 'EVENT') {
        showFlg = true;
      }
    });
    return showFlg;
  }
  private eventAll: string = 'Y';
  private displayEventTypes = {
    name: 'displayEventTypes',
    data: [
      {
        id: 'displayEventTypes_Y',
        value: 'Y',
        dispaly: 'DISPLAY_POPUP_EVENT_ALL'
      },
      {
        id: 'displayEventTypes_N',
        value: 'N',
        dispaly: 'DISPLAY_POPUP_EVENT_PART'
      }
    ]
  };
  private eventNo: string = '';
  private showEventErr: boolean = false;
  private eventNoErrFlg = '';
  private eventNoOptions = {
    name: 'eventNo',
    type: 'text-num'
  };
  private eventInfos: number[] = [];
  private eventErrMsg = '';
  private resetErrFlg() {
    this.showEventErr = false;
  }
  private async addEvent() {
    this.showEventErr = false;
    if (this.eventNo === '') {
      this.showEventErr = true;
      this.eventErrMsg = this.$t('DISPLAY_POPUP_ERR_EVENT_EMPTY') as string;
    } else if (Number(this.eventNo) === 0 || Number(this.eventNo) > 999999999) {
      this.showEventErr = true;
      this.eventErrMsg = this.$t('DISPLAY_POPUP_ERR_EVENT_NOT_HAVE') as string;
    } else if (this.eventInfos.some((info) => info === Number(this.eventNo))) {
      this.showEventErr = true;
      this.eventErrMsg = this.$t('DISPLAY_POPUP_ERR_EVENT_REPEAT') as string;
    } else {
      let request: GetEventsEnentNoRequest = {
        pathParams: {
          eventNo: this.eventNo
        }
      };

      await this.$api
        .getEventsEnentNo(request)
        .then(() => {
          this.eventInfos.push(Number(this.eventNo));
        })
        .catch(() => {
          this.showEventErr = true;
          this.eventErrMsg = this.$t('DISPLAY_POPUP_ERR_EVENT_NOT_HAVE') as string;
        });
    }
  }
  private delEvent(delNo: any) {
    this.eventInfos = this.eventInfos.filter((item: any) => item !== delNo);
  }

  // 상품
  private get showProductInfo() {
    let showFlg = false;
    this.showPageTypes.split(',').forEach((item: any) => {
      if (item === 'PRODUCT') {
        showFlg = true;
      }
    });
    return showFlg;
  }
  private mallProductAll: string = 'Y';
  @Watch('mallProductAll', {immediate: false, deep: false})
  onProductAllChanged(next: string) {
    if (next === 'Y') {
      this.allProductData = [];
      this.showData = [];
      this.totalCount = 0;
      this.nowPage = 1;
      this.gridProps.options.pageOptions.page = 1;
      this.gridProps.options.pageOptions.totalCount = 0;
    }
  }
  private displayProductTypes = {
    name: 'displayProductTypes',
    data: [
      {
        id: 'displayProductTypes_Y',
        value: 'Y',
        dispaly: 'DISPLAY_POPUP_PRODUCT_ALL'
      },
      {
        id: 'displayProductTypes_N',
        value: 'N',
        dispaly: 'DISPLAY_POPUP_PRODUCT_PART'
      }
    ]
  };
  private allProductData: any[] = [];
  private showData: any[] = [];
  private totalCount = 0;
  private nowPage = 1;
  private pageSize = 50;
  private tableOption = {
    noBorder: true,
    onLoadSearch: false,
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    haveDataBodyHeight: 300,
    pageSize: '50',
    pageSizes: [
      {value: '30', name: 'COMMON_PAGE_SIZE_30'},
      {value: '50', name: 'COMMON_PAGE_SIZE_50'},
      {value: '100', name: 'COMMON_PAGE_SIZE_100'}
    ]
  };
  private gridProps = {
    columns: [
      {
        header: 'DISPLAY_POPUP_HERDER_PRODUCT_NO',
        name: 'mallProductNo',
        align: 'center',
        minWidth: 100,
        formatter: this.productNoFormatter
      },
      {
        header: 'DISPLAY_POPUP_HERDER_PRODUCT_NAME',
        name: 'productName',
        align: 'left',
        minWidth: 180
      },
      {
        header: 'DISPLAY_POPUP_HERDER_APPLY_STATUS',
        name: 'applyStatusType',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'DISPLAY_POPUP_HERDER_SALE_STATUS',
        name: 'saleStatusType',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'DISPLAY_POPUP_HERDER_SALE_SETTING_STATUS',
        name: 'saleSettingStatusType',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'DISPLAY_POPUP_HERDER_FRONT_DISPLAY_YN',
        name: 'frontDisplayYn',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return cell.value === 'Y' ? window.$t('DISPLAY_POPUP_DISPLAY_YN_Y') : window.$t('DISPLAY_POPUP_DISPLAY_YN_NONE');
        },
        copyOptions: {
          useFormattedValue: true
        }
      }
    ],
    options: {
      heightResizable: true,
      columnOptions: {
        resizable: true
      },
      pageOptions: {
        perPage: 50,
        page: 1,
        totalCount: 0
      },
      rowHeaders: ['checkbox'],
      keyColumnName: 'mallProductNo',
      bodyHeight: 300
    }
  };
  private productNoFormatter(cell: any) {
    let uri = convertProductUri(this.productDetailUrl, cell.value);
    return `<a target="_blank" href="${uri}" >${cell.value}</a>`;
  }
  private openProductPop() {
    (window as any).addPopupCallback = this.callback;
    localStorage.removeItem('exceptedNos');
    localStorage.setItem('exceptedNos', JSON.stringify(this.allProductData.map((item: any) => item.mallProductNo)));
    ncpPopup(`/product/search/popup?mallNo=${this.mallNo}&callBackName=addPopupCallback&exceptedTarget=addPopupNos`, this.$t('DISPLAY_POPUP_PRODUCT_SEARCH_POP'), 1250, 1024);
  }
  private remove() {
    let productNos = (this.$refs.productTable as any).getCheckedRowKeys();
    if (productNos.length === 0) {
      alert(this.$t('DISPLAY_POPUP_ERR_PRODUCT_NO_SELECT'));
      return;
    }
    this.allProductData = this.allProductData.filter((old: any) => !productNos.some((mallProductNo: number): boolean => mallProductNo === old.mallProductNo));
    this.totalCount = this.allProductData.length;
    this.resetProductData(1);
  }
  private removeAll() {
    this.allProductData = [];
    this.showData = [];
    this.totalCount = 0;
    this.nowPage = 1;
    this.gridProps.options.pageOptions.page = 1;
    this.gridProps.options.pageOptions.totalCount = 0;
  }

  private callback(items: any) {
    (window as any).addPopupCallback = undefined;
    localStorage.removeItem('exceptedNos');
    let productList = items.map((item: any): any => {
      return {
        mallProductNo: item.mallProductNo,
        productName: item.productName,
        applyStatusType: this.$t(`DISPLAY_POPUP_APPLY_STATUS_${item.applyStatusType}`),
        saleStatusType: item.saleStatusType === 'PRE_APPROVAL_STATUS' || item.saleSettingStatusType === 'PROHIBITION_SALE' ? '-' : this.$t(`DISPLAY_POPUP_SALE_STATUS_${item.saleStatusType}`),
        saleSettingStatusType: this.$t(`DISPLAY_POPUP_SALE_SETTING_STATUS_${item.saleSettingStatusType}`),
        frontDisplayYn: item.frontDisplayable ? 'Y' : 'N'
      };
    });
    this.allProductData.push(...productList);
    this.totalCount = this.allProductData.length;
    this.resetProductData(this.nowPage);
  }
  private resetProductData(page: number = 1, size?: number) {
    this.nowPage = page;
    if (size) {
      this.pageSize = size;
    }
    let startIdx = (this.nowPage - 1) * this.pageSize;
    let endIdx = this.nowPage * this.pageSize;
    this.showData = this.allProductData.filter((item: any, idx: number) => startIdx <= idx && idx < endIdx);
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.pageSize;
    this.gridProps.options.pageOptions.totalCount = this.totalCount;
  }

  // 노출 기간
  private startYmdt: string = getToday();
  private endYmdt: string = getToday();
  private periodStartOption = {
    name: 'periodStart',
    havePeriodBtn: false,
    dateType: 'YmdHm',
    fromRanges: getToday(),
    endDate: false,
    detailTime: true,
  };
  private periodEndOption = {
    name: 'periodEnd',
    havePeriodBtn: false,
    dateType: 'YmdHm',
    fromRanges: getToday(),
    endDate: true,
    detailTime: true,
  };

  // 내용
  private initContent: string = '';
  private content: string = '';
  private summerNoteOptions = {
    height: 200,
    width: 475,
    minHeight: 30,
    imageFileSize: 1024,
    toolbar: [
      ['fontsize', ['fontsize']],
      ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
      ['color', ['color']],
      ['para', ['paragraph']],
      ['height', ['height']],
      ['picture', ['picture']],
      ['misc', ['codeview']]
    ]
  };
  private editorOnChange({html}: {html: string}) {
    this.content = html;
  }

  // 노출 우선순위
  private displayNo: number = 1;
  private get spotList() {
    let spots = [];
    for (let i = 1; i <= 5; i++) {
      spots.push({
        value: i,
        name: i.toString() + this.$t('COMMON_SPOT')
      });
    }
    return spots;
  }

  private async save() {
    this.content = this.contentRef.getHtml()
    if (this.checkAll()) {
      let popupInfo = this.getPopupInfo();
      let okFlg = true;
      let okMsg = '';
      if (this.editFlg) {
        let request: PutPopupsPopupNoRequest = {
          pathParams: {
            popupNo: this.editNo
          },
          data: popupInfo
        };
        await this.$api.putPopupsPopupNo(request).catch((e) => {
          if (e.data.code === 'NCPE0001') {
            alert(this.$t('COMMON_SERVER_ERROR_MSG'));
          }
          okFlg = false;
        });
        okMsg = this.$t('DISPLAY_POPUP_EDIT_SUCCESS') as string;
      } else {
        let request: PostPopupsRequest = {
          data: popupInfo
        };
        await this.$api.postPopups(request).catch((e) => {
          if (e.data.code === 'NCPE0001') {
            alert(this.$t('COMMON_SERVER_ERROR_MSG'));
          }
          okFlg = false;
        });
        okMsg = this.$t('DISPLAY_POPUP_ADD_SUCCESS') as string;
      }
      if (okFlg) {
        alert(okMsg);
        this.$router.push('/popup/list');
      }
    }
  }

  private checkAll() {
    if (!emptyCheck(this, this.popupName, 'popupName', 'DISPLAY_POPUP_ERR_NAME_EMPYT')) {
      return false;
    }
    if (!emptyCheck(this, this.popupWidth, 'popupWidth', 'DISPLAY_POPUP_ERR_WIDTH_EMPYT')) {
      return false;
    }
    if (!emptyCheck(this, this.popupHeight, 'popupHeight', 'DISPLAY_POPUP_ERR_HEIGHT_EMPYT')) {
      return false;
    }
    if (this.popupDisplayType === 'CUSTOMIZED' && this.showPlatformTypes === '') {
      alert(this.$t('DISPLAY_POPUP_ERR_DISPLAY_TYPES_EMPYT'));
      (this.$refs.platformType as any).focus();
      return false;
    }
    if (!emptyCheck(this, this.showPageTypes, 'pageTypes', 'DISPLAY_POPUP_ERR_PAGE_TYPES_EMPYT')) {
      return false;
    } else {
      let checkedTypes = this.showPageTypes.split(',');
      if (checkedTypes.some((val) => val === 'CATEGORY') && this.displayCategoryAll === 'N') {
        if (this.categoriesInfo.selectedCategories.length === 0) {
          alert(this.$t('DISPLAY_POPUP_ERR_CATEGORY_EMPYT'));
          (this.$refs.depth1 as any).focus();
          return false;
        }
      }
      if (checkedTypes.some((val) => val === 'EVENT') && this.eventAll === 'N') {
        if (this.eventInfos.length === 0) {
          alert(this.$t('DISPLAY_POPUP_ERR_EVENT_EMPYT'));
          (this.$refs.addEventInput as any).focus();
          return false;
        }
      }
      if (checkedTypes.some((val) => val === 'PRODUCT') && this.mallProductAll === 'N') {
        if (this.allProductData.length === 0) {
          alert(this.$t('DISPLAY_POPUP_ERR_PRODUCT_EMPYT'));
          return false;
        }
      }
    }

    if (this.content === '') {
      alert(this.$t('DISPLAY_POPUP_ERR_CONTENT_EMPYT'));
      (this.$refs.content as any).focus();
      return false;
    }
    return true;
  }

  private getPopupInfo(): any {
    let displayCategoryInfos: any = [];
    if (this.showCategoryInfo && this.displayCategoryAll === 'N') {
      this.categoriesInfo.selectedCategories.forEach((item: any) => {
        displayCategoryInfos.push({
          depth: item.depth,
          displayCategoryNo: item.displayCategoryNo
        });
      });
    }
    let mallProductInfos: number[] = [];
    if (this.showProductInfo && this.mallProductAll === 'N') {
      mallProductInfos = this.allProductData.map((item: any) => item.mallProductNo);
    }
    let popupInfo: any = {
      mallNo: Number(this.mallNo),
      popupName: this.popupName,
      popupWidth: Number(this.popupWidth),
      popupHeight: Number(this.popupHeight),
      popupType: this.popupType as any,
      popupDisplayType: this.popupDisplayType as any,
      applyPageInfoValue: {
        pageTypes: this.showPageTypes.split(',') as any,
        displayCategoryAll: this.showCategoryInfo ? this.displayCategoryAll : 'Y',
        displayCategoryInfos,
        eventAll: this.showEventInfo ? this.eventAll : 'Y',
        eventInfos: this.showEventInfo && this.eventAll === 'N' ? this.eventInfos : [],
        mallProductAll: this.showProductInfo ? this.mallProductAll : 'Y',
        mallProductInfos
      },
      displayPeriod: {
        startYmdt: this.startYmdt === getToday() ? `${this.startYmdt} ${DEFAULT_TIME_RANGE.START}` : this.startYmdt,
        endYmdt: this.endYmdt as any
      },
      content: this.content,
      displayNo: this.displayNo
    };
    if (this.popupDisplayType === 'CUSTOMIZED') {
      popupInfo.platformDisplayType = this.showPlatformTypes.split(',') as any;
    }

    return popupInfo;
  }

  private async setData(editNo: number) {
    let request: GetPopupsPopupNoRequest = {
      pathParams: {
        popupNo: editNo
      }
    };
    let getPopupsPopupNoResponse = await this.$api.getPopupsPopupNo(request);
    let popupInfo: any = getPopupsPopupNoResponse.data;
    // 쇼핑몰
    this.mallNo = String(popupInfo.mallNo);
    // 팝업명
    this.popupName = popupInfo.popupName;
    // 사이즈
    this.popupWidth = String(popupInfo.popupWidth);
    this.popupHeight = String(popupInfo.popupHeight);
    // 형태
    this.popupType = popupInfo.popupType;
    // 적용 페이지 설정
    this.popupDisplayType = popupInfo.popupDisplayType;
    if (popupInfo.popupDisplayType === 'CUSTOMIZED') {
      (this.$refs.platformType as any).setValues(popupInfo.platformDisplayType.join(','));
      this.showPlatformTypes = popupInfo.platformDisplayType.join(',');
    }
    // 적용 페이지 설정
    let pages = popupInfo.applyPageInfoValue.pageTypes.join(',') as string;
    (this.$refs.pageTypes as any).setValues(pages);
    this.showPageTypes = pages;
    // 전시 카테고리
    if (pages.indexOf('CATEGORY') !== -1 && popupInfo.applyPageInfoValue.displayCategoryInfos.length > 0) {
      this.displayCategoryAll = 'N';
      let categoryRequest = {
        params: {
          mallNo: popupInfo.mallNo
        }
      };
      let getDisplayCategoriesResponse = await this.$api.getDisplayCategories(categoryRequest);
      let categories = getDisplayCategoriesResponse.data;
      let allFind = false;
      categories.forEach((category: any) => {
        if (!allFind) {
          popupInfo.applyPageInfoValue.displayCategoryInfos.forEach((item: any) => {
            if (item.depth === category.depth && item.displayCategoryNo === category.displayCategoryNo) {
              let showName = category.fullCategoryName;
              if (category.displayYn === 'N') {
                showName += '<span class="ico_noshow"></span>';
              }
              this.categoriesInfo.selectedCategories.push({
                showName,
                depth: category.depth,
                displayCategoryNo: category.displayCategoryNo
              });
              if (this.categoriesInfo.selectedCategories.length === popupInfo.applyPageInfoValue.displayCategoryInfos.length) {
                allFind = true;
              }
            }
          });
        }
      });
    }
    // 기획전
    if (pages.indexOf('EVENT') !== -1 && popupInfo.applyPageInfoValue.eventInfos.length > 0) {
      this.eventAll = 'N';
      this.eventInfos = popupInfo.applyPageInfoValue.eventInfos;
    }
    // 상품
    if (pages.indexOf('PRODUCT') !== -1 && popupInfo.applyPageInfoValue.mallProductInfos.length > 0) {
      this.mallProductAll = 'N';
      let searchByKeyRequest: PostProductsSearchByKeyRequest = {
        data: {
          mallNos: [popupInfo.mallNo],
          mallProductNos: popupInfo.applyPageInfoValue.mallProductInfos,
        }
      };
      let searchByKeyResponse = await this.$api.postProductsSearchByKey(searchByKeyRequest);
      let productList = searchByKeyResponse.data.map((item: any): any => {
        return {
          mallProductNo: item.mallProductNo,
          productName: item.productName,
          applyStatusType: this.$t(`DISPLAY_POPUP_APPLY_STATUS_${item.applyStatusType}`),
          saleStatusType: item.saleStatusType === 'PRE_APPROVAL_STATUS' || item.saleSettingStatusType === 'PROHIBITION_SALE' ? '-' : this.$t(`DISPLAY_POPUP_SALE_STATUS_${item.saleStatusType}`),
          saleSettingStatusType: this.$t(`DISPLAY_POPUP_SALE_SETTING_STATUS_${item.saleSettingStatusType}`),
          frontDisplayYn: item.frontDisplayable ? 'Y' : 'N'
        };
      });
      this.allProductData.push(...productList);
      this.totalCount = this.allProductData.length;
      this.resetProductData(1);
    }
    // 노출 기간
    this.startYmdt = popupInfo.displayPeriod.startYmdt;
    this.endYmdt = popupInfo.displayPeriod.endYmdt;
    // 내용
    this.initContent = popupInfo.content;
    // 노출 우선순위
    this.displayNo = popupInfo.displayNo;

    this.editFlg = true;
    this.editNo = editNo;
  }

  private validateDisplayPeriod(
    validTarget: 'start' | 'end',
    oldValue: string,
  ): void {
    this.$nextTick(() => {
      const startDateTime = moment(this.startYmdt)
        .toDate()
        .getTime();
      const endDateTime = moment(this.endYmdt)
        .toDate()
        .getTime();
      const overflow = startDateTime > endDateTime;

      if (!overflow) return;
      if (validTarget === 'start') {
        this.startYmdt = oldValue;
      }
      if (validTarget === 'end') {
        this.endYmdt = oldValue;
      }
      return alert(this.$t('COMMON_DATE_SPAN_ERR'));
    });
  }

  private async mounted() {
    await this.fetchMalls();
    this.mallNo = this.malls[0].mallNo.toString();
    let mallConf = await this.$api.getProductsConfiguration({params: {mallNo: Number(this.mallNo)}});
    this.productDetailUrl = addProductDetailUrlPreview(mallConf.data.productDetailUrl);
    let editNo = '';
    if (this.$route.query.popupNo) {
      editNo = this.$route.query.popupNo as string;
    }

    if (editNo !== '') {
      this.setData(Number(editNo));
    }
    const {data} = await this.$api.getDisplayCategoriesTree({params: {mallNo: Number(this.mallNo)}});
    this.categoriesInfo.categoriesTree = data;
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    let noData = this.$t('DISPLAY_POPUP_DETAIL_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
  private beforeDestroy(): void {
    let noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
}
